import React, {createContext, useState} from 'react';
import {Toast} from "../components/common/Toast";
import {getErrorMessage} from "../helpers/Utils";
import TableLayoutService from "../services/TableLayoutService";

export const TableLayoutContext = createContext("TableLayoutContext");

const TableLayoutContextProvider = ({children}) => {

    const [tableLayoutList, setTableLayoutList] = useState([]);
    const [totalElements, setTotalElements] = useState(0);
    const [loadingTableLayoutList, setLoadingTableLayoutList] = useState(false);

    const getTableLayoutList = async params => {

        try {
            setLoadingTableLayoutList(true);
            const res = await TableLayoutService.getTableLayoutList(params);
            setTableLayoutList(res.data.content);
            setTotalElements(res.data.totalElements);
            setLoadingTableLayoutList(false);
        } catch (error) {
            setLoadingTableLayoutList(false);
            const message = getErrorMessage(error);
            Toast('error', "Error", message);
        }

    }

    const getTableLayoutListByOwner = async params => {

        try {
            setLoadingTableLayoutList(true);
            const res = await TableLayoutService.getTableLayoutListByOwner(params);
            setTableLayoutList(res.data.content);
            setTotalElements(res.data.totalElements);
            setLoadingTableLayoutList(false);
        } catch (error) {
            setLoadingTableLayoutList(false);
            const message = getErrorMessage(error);
            Toast('error', "Error", message);
        }

    }

    return (
        <TableLayoutContext.Provider
            value={{
                getTableLayoutList,
                getTableLayoutListByOwner,
                tableLayoutList,
                loadingTableLayoutList,
                totalElements
            }}
        >
            {children}
        </TableLayoutContext.Provider>
    );
}

export default TableLayoutContextProvider;
